import React from "react";

import { connect } from "react-redux";
import ContentWrapper from "../../../lib_react_adminlte/componentes/ContentWrapper.jsx";
import Api from "../../../utils/Api.jsx";
import CountBox from "../../../componentes/CountBox.jsx";
import { Column } from "../../../lib_react_adminlte/componentes/Table.jsx";
import ApiceComboEditPanel from "../../../lib_react_adminlte/componentes/ApiceComboEditPanel.jsx";

import constants_initial_state from "../../../utils/constants_initial_state";
import Button from "../../../lib_react_adminlte/componentes/Button.jsx";
import constants from "../../../utils/constants";

import Cookies from "../../../lib_react_frontend/utils/Cookies.jsx";

const initialState = constants_initial_state.initialState;

let cookies = {
  cod_empresa_dashboard: "",
};

const tipos_1 = [1, 2, 4, 5];
const tipos_2 = [1, 2, 3];
const tipos_3 = [1, 2, 3, 5];

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

class Dashboard extends React.Component {
  state = { ...initialState };

  async componentDidMount() {
    Cookies.erase("empresa");
    this.validaUnicaEmpresa();

    let id_pk = "";

    if (Cookies.get("empresa")) {
      cookies = Cookies.get("empresa");

      id_pk =
        cookies && cookies.cod_empresa_dashboard
          ? cookies.cod_empresa_dashboard
          : "";
    } else if (
      this.props.usuario.empresas &&
      this.props.usuario.empresas.length > 0
    ) {
      id_pk = this.props.usuario.empresas[0].id_pk;
    }

    this.setState({
      empresa: id_pk,
    });

    const dezAnos = new Date(
      new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 10
    );

    Cookies.set(
      "empresa",
      {
        cod_empresa_dashboard: id_pk,
      },
      dezAnos
    );

    this.carregaBiInfo(id_pk);

    // Nao sei quando isto vem alimentado...
    // Talvez quando vem de relatorios...
    if (this.props.location.state) {
      this.setState({
        hash: this.props.location.state.hash,
        data: this.props.location.state.data,
      });
    }
  }

  async validaUnicaEmpresa() {
    if (!Cookies.get("empresa")) {
      const ret = await Api.buscar(
        "tab_empresa",
        "",
        this.props.usuario.tipo_usuario != constants.tipo_usuario_admin
          ? `b.cod_usuario = ${this.props.usuario.cod_usuario} AND a.status_ativo = 'S'`
          : `a.status_ativo = 'S'`
      );

      if (ret && ret.dados && ret.dados.length == 1) {
        this.setState({
          empresa: ret.dados[0].id_pk,
        });
      }
    }
  }

  async carregaBiInfo(id_pk) {
    if (id_pk) {
      const dados = await Api.buscar(
        "tab_empresa_bi_inf",
        "",
        " AND id_pk = " + id_pk
      );

      if (dados.dados) {
        this.props.dispatch({
          type: "set_ultima_atualizacao",
          dados: {
            ...this.props.ultimaAtualizacao,
            dt_hr_ultima_sincronizacao: dados.dados.dt_hr_ultima_sincronizacao,
          },
        });
      }

      // Preciso guardar o cookies

      cookies.cod_empresa_dashboard = id_pk;

      const dezAnos = new Date(
        new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 10
      );

      Cookies.set(
        "empresa",
        {
          ...cookies,
        },
        dezAnos
      );

      this.setState({
        ...this.state,
        ...dados.dados,
        empresa: id_pk,
        updateComponent: false,
        carregar_estoque: false,
      });
    }
  }

  async carregaTodasEmpresas() {
    // Quando for administrador nao pode realizar esta tarefa... precisa alertar o usuario
    const dados = await Api.buscar(
      "tab_empresa_bi_inf_todas",
      "",
      "" + this.props.usuario.ids_filiais
    );

    if (dados && dados.dados) {
      this.props.dispatch({
        type: "set_ultima_atualizacao",
        dados: {
          ...this.props.ultimaAtualizacao,
          dt_hr_ultima_sincronizacao: dados.dados.dt_hr_ultima_sincronizacao,
        },
      });
    }

    console.log("dados ", dados);

    this.setState({
      ...this.state,
      ...dados.dados,
      empresa: "",
      updateComponent: false,
      carregar_estoque: true,
    });
  }

  render() {
    return (
      <ContentWrapper tiraTitulo ref={(e) => (this.tela = e)}>
        <div
          className="d-flex flex-row"
          style={
            this.props.usuario.tipo_usuario === constants.tipo_usuario_admin
              ? {}
              : { marginLeft: "-6px" }
          }
        >
          <Button
            label="Ver todas"
            icon="fa-search"
            style={{ marginBottom: isMobile ? "8px" : "0.5%" }}
            hidden={
              this.props.usuario.tipo_usuario === constants.tipo_usuario_admin
                ? true
                : false
            }
            onClick={() => this.carregaTodasEmpresas()}
          />
          <div
            className="flex ml-5"
            style={{
              maxWidth:
                this.props.usuario.tipo_usuario === constants.tipo_usuario_admin
                  ? "99.1%"
                  : "93%",
              marginBottom: "2px",
              marginLeft:
                this.props.usuario.tipo_usuario === constants.tipo_usuario_admin
                  ? "-5px"
                  : null,
            }}
          >
            <ApiceComboEditPanel
              tabela="tab_empresa"
              chave="id_pk"
              desc="nome_fantasia"
              btnClass="btn-blue"
              escondeInput
              usaLabel={"nome_fantasia"}
              onChange={(e) => {
                this.carregaBiInfo(e.target.value.id_pk);
              }}
              where={
                this.props.usuario.ids_filiais &&
                this.props.usuario.ids_filiais !== ""
                  ? ` and a.id_pk in (${this.props.usuario.ids_filiais}) `
                  : ""
              }
              colunas={[
                <Column
                  key={0}
                  style={{ width: "75%" }}
                  field="nome_fantasia"
                  header="Nome"
                />,
                <Column
                  key={1}
                  style={{ width: "25%" }}
                  field="doc_federal"
                  header="CPF/CNPJ"
                />,
              ]}
              pagination
              tableMaxHeight={isMobile ? window.innerHeight - 300 : 400}
              retornaObjeto
              value={this.state.empresa}
              api={Api}
            />
          </div>
        </div>

        <div
          className="Contadores"
          style={{ margin: "-5px", marginBottom: "-20px" }}
        >
          {tipos_1.includes(this.props.usuario.tipo_usuario) && (
            <CountBox
              dados={{
                icon: "fa-shopping-cart",
                title: "Vendas em Tempo Real (Diário)",
                bgColor: "bg-blue",
                smallText2: "Vr. Venda do Dia:",
                value1: this.state.valor_venda_tempo_real_venda,
                smallText3: "Vr. Meta do Dia:",
                value2: this.state.valor_venda_tempo_real_meta,
                smallText4: "Margem de lucro:",
                value3: this.state.valor_venda_tempo_real_margem + "%",
                // bigTextBottom: vrTotal,
                syles: { marginTop: "4%" },
                grafic: true,
                valorGrafico1: this.state.valor_venda_tempo_real_perc_meta,
                valorGrafico2:
                  100 - this.state.valor_venda_tempo_real_perc_meta,
              }}
            />
          )}
          {tipos_1.includes(this.props.usuario.tipo_usuario) && (
            <CountBox
              dados={{
                icon: "fa-shopping-cart",
                syles: { marginTop: "4%" },
                title: "Vendas em Tempo Real (Mês)",
                bgColor: "bg-blue",
                smallText2: "Vr. Venda do Mês:",
                value1: this.state.valor_venda_mes_venda,
                smallText3: "Vr. Meta do Mês:",
                value2: this.state.valor_venda_mes_meta,
                smallText4: "Margem de lucro:",
                value3: this.state.valor_venda_mes_margem + "%",
                grafic: true,
                valorGrafico1: this.state.valor_venda_mes_perc_meta,
                valorGrafico2: 100 - this.state.valor_venda_mes_perc_meta,
              }}
            />
          )}
          {tipos_1.includes(this.props.usuario.tipo_usuario) && (
            <CountBox
              dados={{
                icon: "fa-ticket",
                // syles: { marginTop: "2%" },
                title: "Ticket Médio (Diário)",
                bgColor: "bg-purple",
                smallText: "Vr. Ticket Médio (Pedido):",
                value1: this.state.valor_ticket_medio_dia_ped,
                smallText2: "Vr. Ticket Médio (Cliente):",
                value2: this.state.valor_ticket_medio_dia_cli,
                smallText3: "Vr. Ticket Médio (Pedido):",
                value3: this.state.valor_ticket_medio_mes_ped,
                smallText4: "Vr. Ticket Médio (Cliente):",
                title2: "Ticket Médio (Mensal)",
                value4: this.state.valor_ticket_medio_mes_cli,
                usaBarra: true,
                usaBarraHorizontal: true,
              }}
            />
          )}
          {tipos_2.includes(this.props.usuario.tipo_usuario) && (
            <CountBox
              dados={{
                icon: "fa-money",
                // syles: { marginTop: "2%" },
                title: "(Diário)",
                bgColor: "bg-red",
                smallText: this.state.valor_a_pagar_dia_valor,
                smallText2:
                  "Qtd. Reg.:" + " " + this.state.valor_a_pagar_dia_qtde,
                smallText3: "(Diário)",
                smallText4: this.state.valor_pagas_dia_valor,
                smallText5:
                  "Qtd. Reg.:" + " " + this.state.valor_pagas_dia_qtde,
                title2: "Ticket Médio (Mensal)",

                smallText6: "(Mensal)",
                smallText7: this.state.valor_a_pagar_mes_valor,
                smallText8:
                  "Qtd. Reg.:" + " " + this.state.valor_a_pagar_mes_qtde,
                smallText9: "(Mensal)",
                smallText10: this.state.valor_pagas_mes_valor,
                smallText11:
                  "Qtd. Reg.:" + " " + this.state.valor_pagas_mes_qtde,
                usaBarraVertical: true,

                titleV1: "Contas a Pagar",
                titleV2: "Contas Pagas",
              }}
            />
          )}
          {tipos_3.includes(this.props.usuario.tipo_usuario) && (
            <CountBox
              dados={{
                icon: "fa-money",
                // syles: { marginTop: "2%" },
                title: "(Diário)",
                bgColor: "bg-green",
                smallText: this.state.valor_a_receber_dia_valor,
                smallText2:
                  "Qtd. Reg.:" + " " + this.state.valor_a_receber_dia_qtde,
                smallText3: "(Diário)",
                smallText4: this.state.valor_recebidas_dia_valor,
                smallText5:
                  "Qtd. Reg.:" + " " + this.state.valor_recebidas_dia_qtde,

                smallText6: "(Mensal)",
                smallText7: this.state.valor_a_receber_mes_valor,
                smallText8:
                  "Qtd. Reg.:" + " " + this.state.valor_a_receber_mes_qtde,
                smallText9: "(Mensal)",
                smallText10: this.state.valor_recebidas_mes_valor,
                smallText11:
                  "Qtd. Reg.:" + " " + this.state.valor_recebidas_mes_qtde,
                usaBarraVertical: true,

                titleV1: "Contas a Receber",
                titleV2: "Contas Recebidas",
              }}
            />
          )}

          {/* Ranking Grupo de Produto */}
          {tipos_1.includes(this.props.usuario.tipo_usuario) && (
            <CountBox
              dados={{
                // syles: { marginTop: "2%" },
                icon: "fa-area-chart",
                title: "Ranking Grupo de Produto (Diário):",
                bgColor: "bg-yellow",
                lookmore: "Ver mais...",
                productColumns: true,
                normal: true,
                between: true,
                between1: true,
                between2: true,
                dados_tabela: this.state.ranking_grupo_produto_diario,
              }}
            />
          )}
          {tipos_1.includes(this.props.usuario.tipo_usuario) && (
            <CountBox
              dados={{
                // syles: { marginTop: "2%" },
                icon: "fa-area-chart",
                title: "Ranking Grupo de Produto (Mensal):",
                bgColor: "bg-yellow",
                productColumns: true,

                lookmore: "Ver mais...",
                normal: true,

                between: true,
                between1: true,
                between2: true,
                dados_tabela: this.state.ranking_grupo_produto_mensal,
              }}
            />
          )}

          {/* Ranking Produto */}
          {tipos_1.includes(this.props.usuario.tipo_usuario) && (
            <CountBox
              dados={{
                // syles: { marginTop: "2%" },
                icon: "fa-archive",
                title: "Ranking Produto (Diário):",
                bgColor: "bg-darken-2",

                lookmore: "Ver mais...",
                normal: true,

                between: true,
                between1: true,
                between2: true,
                clienteColumns: true,
                dados_tabela: this.state.ranking_produto_diario,
              }}
            />
          )}
          {tipos_1.includes(this.props.usuario.tipo_usuario) && (
            <CountBox
              dados={{
                // syles: { marginTop: "2%" },
                icon: "fa-archive",
                title: "Ranking Produto (Mensal):",
                bgColor: "bg-darken-2",

                lookmore: "Ver mais...",
                normal: true,

                between: true,
                between1: true,
                between2: true,
                clienteColumns: true,
                dados_tabela: this.state.ranking_produto_mensal,
              }}
            />
          )}

          {/* Ranking Vendedor */}
          {tipos_1.includes(this.props.usuario.tipo_usuario) && (
            <CountBox
              dados={{
                // syles: { marginTop: "2%" },
                icon: "fa-user",
                title: "Ranking Vendedor (Diário):",
                bgColor: "bg-white",

                lookmore: "Ver mais...",
                vendedorColumns: true,
                normal: true,
                between: true,
                between1: true,
                between2: true,

                dados_tabela: this.state.ranking_vendedor_diario,
              }}
            />
          )}
          {tipos_1.includes(this.props.usuario.tipo_usuario) && (
            <CountBox
              dados={{
                // syles: { marginTop: "2%" },
                icon: "fa-user",
                title: "Ranking Vendedor (Mensal):",
                bgColor: "bg-white",

                lookmore: "Ver mais...",
                vendedorColumns: true,
                normal: true,
                between: true,
                between1: true,
                between2: true,

                dados_tabela: this.state.ranking_vendedor_mensal,
              }}
            />
          )}

          {/* Ranking Cliente */}
          {tipos_1.includes(this.props.usuario.tipo_usuario) && (
            <CountBox
              dados={{
                // syles: { marginTop: "2%" },
                icon: "fa-users",
                title: "Ranking Cliente (Diário):",
                bgColor: "bg-orange",

                lookmore: "Ver mais...",
                normal: true,

                between: true,
                between1: true,
                between2: true,
                clienteColumns: true,
                dados_tabela: this.state.ranking_cliente_diario,
              }}
            />
          )}
          {tipos_1.includes(this.props.usuario.tipo_usuario) && (
            <CountBox
              dados={{
                // syles: { marginTop: "2%" },
                icon: "fa-users",
                title: "Ranking Cliente (Mensal):",
                bgColor: "bg-orange",

                lookmore: "Ver mais...",
                normal: true,

                between: true,
                between1: true,
                between2: true,
                clienteColumns: true,
                dados_tabela: this.state.ranking_cliente_mensal,
              }}
            />
          )}

          {/* Ranking de Venda */}
          {tipos_1.includes(this.props.usuario.tipo_usuario) && (
            <CountBox
              dados={{
                // syles: { width: "100%" },
                icon: "fa-users",
                title: "Ranking de Venda (Diário):",
                bgColor: "bg-olive",

                lookmore: "Ver mais...",
                normal: true,

                between: true,
                between1: true,
                between2: true,
                clienteColumns: true,
                dados_tabela: this.state.ranking_venda_diario,
              }}
            />
          )}

          
          {tipos_1.includes(this.props.usuario.tipo_usuario) && this.state.carregar_estoque  && (  
              <CountBox
                personalizado
                dados={{
                  icon: "fa-calculator",
                  title: "Estoque:",
                  bgColor: "bg-blue",
              
                  smallText1: "Vr. Estoque Geral:",
                  value1: this.state.vr_total_estoque_geral,
              
                  smallText2: "Vr. Estoque Venda Futura:",
                  value2: this.state.vr_total_estoque_venda_futura,
              
                  smallText3: "Vr Estoque Líquido:",
                  value3: this.state.vr_total_estoque_liquido,
              
                  // bigTextBottom: vrTotal,
                  syles: { marginTop: "4%" },
                  grafic: false, 
                }}
              />
          )}
        </div>
      </ContentWrapper>
    );
  }
}

export default connect(
  (state) => ({
    usuario: state.usuario,
    ultimaAtualizacao: state.ultimaAtualizacao,
  }),
  (dispatch) => ({
    dispatch,
  })
)(Dashboard);



// WEBPACK FOOTER //
// ./src/telas/Cadastros/Dashboard/index.jsx